import React, { useEffect, useState } from "react";
import { Controller, SubmitHandler, useForm } from "react-hook-form";
import toast from "react-hot-toast";
import { FaAngleLeft, FaPencil, FaPlus } from "react-icons/fa6";
import { MdClose, MdDelete } from "react-icons/md";
import "react-quill/dist/quill.snow.css";
import { useNavigate, useParams } from "react-router-dom";
import Select from "react-select";
import { workOutExerciseCreateInterface } from "../../api/types/types";
import { useGetExercises } from "../../api/useProducts/useExercises";
import {
  useCreateWorkOutExercises,
  useDeleteWorkoutExercises,
  useGetWorkOutById,
  useUpdateWorkOutExercises,
} from "../../api/useProducts/useWorkOut";
import { CustomButton, InputField, Sidebar } from "../../components";
import { TimePicker } from "antd";
import UpdateAddWorkoutExercises from "./UpdateAddWorkoutExercises";
import Swal from "sweetalert2";
import dayjs from "dayjs";
import moment from "moment";
import CustomBreadcrumb from "../../components/CustomBreadcrumb";
// Form data interface
interface WorkoutFormData {
  exercises: { value: string; label: string };
  order: number;
  duration: string;
  reps: number;
  sets: number;
  id?: number;
}

const UpdateWorkoutExercises: React.FC = () => {
  const { id } = useParams();
  const { WorkoutData, WorkoutLoading, WorkoutRefetch } = useGetWorkOutById(
    Number(id)
  );
  const [exerciseId, seteExerciseId] = useState<Number>();
  const { mutate, isPending } = useUpdateWorkOutExercises(Number(exerciseId));
  const [isMoreWorkOuts, setIsMoreWorkOuts] = useState<boolean>(false);

  const { exercisesData, exercisesLoading, exercisesRefetch } = useGetExercises(
    {
      page: 1,
      limit: 100000,
    }
  );
  const { mutate: mutateExercise } = useDeleteWorkoutExercises();
  const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    reset,
    watch,
    setValue,
    formState: { errors },
    control,
  } = useForm<WorkoutFormData>();
  const [exerciseList, setExerciseList] = useState<WorkoutFormData[]>([]);
  const [isExerciseList, setIsExerciseList] = useState<boolean>(false);

  console.log(exerciseList);
  const handleSave: SubmitHandler<WorkoutFormData> = (data) => {
    // setExerciseList((prevList = []) => [...prevList, data]);
    // reset();
    // setIsExerciseList(false);
    mutate(
      {
        // @ts-ignore
        sets: Number(data.sets),
        reps: Number(data.reps),
        order: Number(data.order),
        // @ts-ignore

        duration: moment(data.duration.$d).format("HH:mm:ss"),
        exerciseId: parseInt(data.exercises.value),
      },
      {
        onSuccess: (data) => {
          toast.success("successfully update");
          // navigate(`/workouts`);
          setIsExerciseList(false);
          WorkoutRefetch();
          reset();
          seteExerciseId(undefined);
        },
        onError: (error: any) => {
          toast.error(error.response.data.message);
        },
      }
    );
  };

  const handleDelete = (id: number) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#24B1B3",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        mutateExercise(
          { id },
          {
            onSuccess: (data) => {
              toast.success("successfully delete");
              WorkoutRefetch();
            },
            onError: (error: any) => {
              console.error("Error deleting item:", error);
              toast.error(error.response.data.message);
            },
          }
        );
      }
    });
  };

  const handleEdit = (value: any) => {
    seteExerciseId(value?.id);
    // @ts-ignore
    setValue("duration", dayjs(value.duration, "HH:mm:ss"));
    setValue("reps", value.reps);
    setValue("sets", value.sets);
    setValue("order", value.order);
    setValue("exercises", value.exercises);
    setIsExerciseList(true);
  };
  useEffect(() => {
    WorkoutRefetch();
  }, [id]);
  useEffect(() => {
    if (WorkoutData?.workoutExercises) {
      const transformedExercises = WorkoutData.workoutExercises.map(
        (exercise) => ({
          exercises: {
            value: exercise.exerciseId.toString(),
            label: exercise.exercise.title,
          },
          order: exercise.order,
          duration: `${exercise.duration}`, // Extract the hour part
          reps: exercise.reps,
          sets: exercise.sets,
          id: exercise.id,
        })
      );
      console.log("Transformed Exercises: ", transformedExercises);
      setExerciseList(transformedExercises);
    } else {
      console.log("No WorkoutData or workoutExercises found");
    }
  }, [id, WorkoutData]);
  const breadcrumbItems = [
    { title: "Workouts", link: "workouts" },
    { title: "Exercise " },
  ];
  return (
    <Sidebar>
      {!isMoreWorkOuts ? (
        <>
          <div className="mt-3">
            <CustomBreadcrumb items={breadcrumbItems} />
          </div>
          {/* <CustomButton
            handleClick={() => navigate("/workouts")}
            icon={<FaAngleLeft size={22} />}
            rounded="rounded-full"
            padding="p-0"
            addclass="mt-4  w-8 h-8"
          /> */}
          <div className="flex justify-between items-center mb-2">
            <h1 className="font-medium mt-5 mb-4 text-2xl">
              Workout Exercise{isExerciseList ? "" : "s"}
            </h1>

            {isExerciseList && (
              <CustomButton
                handleClick={() => {
                  setIsExerciseList(false);
                  seteExerciseId(undefined);
                }}
                icon={<MdClose size={22} />}
                rounded="rounded-full"
                padding="p-0"
                addclass="mt-4 ms-auto w-8 h-8"
              />
            )}
          </div>
          {!isExerciseList ? (
            <div>
              {exerciseList?.length > 0 ? (
                exerciseList?.map((value, idx) => {
                  return (
                    <div
                      key={idx}
                      className="border-2 border-darkCyan overflow-hidden rounded-lg p-4 mb-3 relative"
                    >
                      <span
                        className="absolute top-0 end-8 cursor-pointer w-7 h-7 flex justify-center items-center rounded-b-lg  bg-darkCyan text-white"
                        onClick={() => handleEdit(value)}
                      >
                        <FaPencil size={16} />
                      </span>
                      <span
                        className="absolute top-0 end-0 cursor-pointer w-7 h-7 flex justify-center items-center rounded-bl-lg  bg-darkCyan text-white"
                        onClick={() => handleDelete(Number(value?.id))}
                      >
                        <MdDelete size={20} />
                      </span>
                      <p className="font-semibold">
                        Reps :
                        <span className="text-gray-500 font-normal ms-1.5">
                          {" "}
                          {value?.reps}
                        </span>
                      </p>
                      <p className="font-semibold">
                        Sets :
                        <span className="text-gray-500 font-normal ms-1.5">
                          {value?.sets}{" "}
                        </span>
                      </p>
                      <p className="font-semibold">
                        Duration :
                        <span className="text-gray-500 font-normal ms-1.5">
                          {value?.duration}
                        </span>
                      </p>
                      <p className="font-semibold">
                        Exercises :
                        <span className="text-gray-500 font-normal ms-1.5">
                          {value?.exercises.label}
                        </span>
                      </p>
                      <p className="font-semibold">
                        Order :
                        <span className="text-gray-500 font-normal ms-1.5">
                          {value?.order}
                        </span>
                      </p>
                    </div>
                  );
                })
              ) : (
                <div className="border-2 rounded-lg p-3 text-center mt-4 min-h-32 flex justify-center items-center">
                  Data not found
                </div>
              )}
              <CustomButton
                handleClick={() => setIsMoreWorkOuts(true)}
                icon={<FaPlus size={22} />}
                rounded="rounded-full"
                padding="p-0"
                addclass="mt-4 ms-auto w-8 h-8"
              />
            </div>
          ) : (
            <form onSubmit={handleSubmit(handleSave)}>
              <div>
                <div className="grid lg:grid-cols-2 grid-cols-1 gap-3 ">
                  <InputField
                    label="Reps"
                    placeholder="Enter reps"
                    type="number"
                    register={register(`reps`, {
                      required: "Reps are required",
                      validate: (value) => {
                        // @ts-ignore
                        if (value <= 0) {
                          return "reps must be a positive number";
                        }
                        // @ts-ignore
                        if (!Number.isInteger(parseFloat(value))) {
                          return "reps must be a whole number";
                        }
                        return true;
                      },
                    })}
                    error={errors.reps?.message}
                  />
                  <InputField
                    label="Sets"
                    placeholder="Enter set"
                    type="number"
                    register={register(`sets`, {
                      required: "Sets are required",
                      validate: (value) => {
                        // @ts-ignore
                        if (value <= 0) {
                          return "Sets must be a positive number";
                        }
                        // @ts-ignore
                        if (!Number.isInteger(parseFloat(value))) {
                          return "Sets must be a whole number";
                        }
                        return true;
                      },
                    })}
                    error={errors.sets?.message}
                  />
                  <div>
                    <p className="block text-gray-700 mb-2">Duration</p>

                    <Controller
                      name="duration"
                      control={control}
                      rules={{
                        required: "duration are required",
                        min: {
                          value: 1,
                          message: "duration must be at least 1",
                        },
                      }}
                      render={({ field }) => (
                        // @ts-ignore
                        <TimePicker
                          {...field}
                          className="!focus:shadow-none w-full h-11 !focus:border-gray-300 hover:shadow-none hover:border-gray-300 text-sm"
                        />
                      )}
                    />
                    {errors.duration && (
                      <p className="text-red-500 text-sm mt-1">
                        {errors.duration.message}
                      </p>
                    )}
                  </div>

                  <InputField
                    label="order"
                    placeholder="Enter order"
                    type="number"
                    register={register(`order`, {
                      required: "Order is required",
                      validate: (value) => {
                        // @ts-ignore
                        if (value <= 0) {
                          return "order must be a positive number";
                        }
                        // @ts-ignore
                        if (!Number.isInteger(parseFloat(value))) {
                          return "order must be a whole number";
                        }
                        return true;
                      },
                    })}
                    error={errors.order?.message}
                  />

                  <div>
                    <p className="block text-gray-700 mb-2">Exercises</p>
                    <Controller
                      name={`exercises`}
                      control={control}
                      rules={{ required: "Exercise is required" }}
                      render={({ field }) => (
                        <Select
                          {...field}
                          isDisabled={exercisesLoading}
                          options={exercisesData?.data.map((exercise) => ({
                            value: exercise.id.toString(),
                            label: exercise.title,
                          }))}
                          placeholder="Select exercises"
                          styles={{
                            control: (base) => ({
                              ...base,
                              height: "44px", // Background color for the select control
                              boxShadow: "none",
                              caretColor: "#24B1B3",
                              border: "1px solid #E5E7EB",
                              borderRadius: "8px",
                              fontSize: "14px",
                              "&:focus": {
                                outline: "none !important",
                                boxShadow: "none !important",
                                borderColor: "gray !important",
                              },
                              "&:hover": { borderColor: "none !important" },
                            }),
                            placeholder: (base) => ({
                              ...base,
                              color: "rgb(148 163 184)", // Set placeholder color here
                            }),
                          }}
                        />
                      )}
                    />
                    {errors.exercises && (
                      <p className="text-red-500 text-sm mt-1">
                        {errors.exercises?.message}
                      </p>
                    )}
                  </div>
                </div>
              </div>

              <CustomButton
                type="submit"
                isLoading={isPending}
                btntext="Save"
                addclass="mt-5 mx-auto w-1/2"
              />
            </form>
          )}
        </>
      ) : (
        <UpdateAddWorkoutExercises
          setIsMoreWorkOuts={setIsMoreWorkOuts}
          WorkoutRefetch={WorkoutRefetch}
        />
      )}
    </Sidebar>
  );
};

export default UpdateWorkoutExercises;
